// extracted by mini-css-extract-plugin
module.exports = {"reviewsSummaryLabel":"style_reviewsSummaryLabel__1jlKu","reviewsSummaryTooltip":"style_reviewsSummaryTooltip__2JRhf","tooltip":"style_tooltip__NFsM-","arrow":"style_arrow__1VQiP"};